export const groupBy = <TItem, TBy extends string | number | symbol>(
  items: TItem[],
  by: (item: TItem) => TBy
): Record<TBy, TItem[]> => {
  return items.reduce((groups, item) => {
    (groups[by(item)] ||= []).push(item);
    return groups;
  }, {} as Record<TBy, TItem[]>);
};
